/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ frameRate: NonNullable<unknown> }} New_Project_Update_Frame_Rate_PromptInputs */

const en_new_project_update_frame_rate_prompt = /** @type {(inputs: New_Project_Update_Frame_Rate_PromptInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Would you like to update the Project frame rate to match the frame rate found in the media (${i?.frameRate})?`)
};

const fr_new_project_update_frame_rate_prompt = /** @type {(inputs: New_Project_Update_Frame_Rate_PromptInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Voulez-vous mettre a jour la cadence du projet pour correspondre a celle detectee dans le media (${i?.frameRate}) ?`)
};

const de_new_project_update_frame_rate_prompt = /** @type {(inputs: New_Project_Update_Frame_Rate_PromptInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Möchten Sie die Bildrate des Projekts an die Bildrate der Mediendatei (${i?.frameRate}) anpassen?`)
};

const it_new_project_update_frame_rate_prompt = /** @type {(inputs: New_Project_Update_Frame_Rate_PromptInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Desideri aggiornare il frame rate del progetto in modo che corrisponda al frame rate trovato nel supporto (${i?.frameRate})?`)
};

const ru_new_project_update_frame_rate_prompt = /** @type {(inputs: New_Project_Update_Frame_Rate_PromptInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Хотите обновить частоту кадров проекта, чтобы она соответствовала частоте кадров, найденной в медиафайле (${i?.frameRate})?`)
};

const es_new_project_update_frame_rate_prompt = /** @type {(inputs: New_Project_Update_Frame_Rate_PromptInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¿Le gustaría actualizar la velocidad de cuadros del proyecto para que coincida con la velocidad de cuadros encontrada en el medio (${i?.frameRate})?`)
};

const zh_cn2_new_project_update_frame_rate_prompt = /** @type {(inputs: New_Project_Update_Frame_Rate_PromptInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`您是否要将项目帧速率更新为与媒体中找到的帧速率 (${i?.frameRate}) 相匹配？`)
};

const ja_new_project_update_frame_rate_prompt = /** @type {(inputs: New_Project_Update_Frame_Rate_PromptInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`プロジェクトのフレーム レートを、メディア (${i?.frameRate}) のフレーム レートに合わせて更新しますか?`)
};

const hi_new_project_update_frame_rate_prompt = /** @type {(inputs: New_Project_Update_Frame_Rate_PromptInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`क्या आप प्रोजेक्ट फ्रेम दर को मीडिया (${i?.frameRate}) में पाई गई फ्रेम दर से मेल खाने के लिए अपडेट करना चाहेंगे?`)
};

const pt_pt2_new_project_update_frame_rate_prompt = /** @type {(inputs: New_Project_Update_Frame_Rate_PromptInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Deseja atualizar a taxa de quadros do projeto para corresponder à taxa de quadros encontrada na mídia (${i?.frameRate})?`)
};

/**
* | output |
* | --- |
* | "Would you like to update the Project frame rate to match the frame rate found in the media ({frameRate})?" |
*
* @param {New_Project_Update_Frame_Rate_PromptInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_update_frame_rate_prompt = /** @type {((inputs: New_Project_Update_Frame_Rate_PromptInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Update_Frame_Rate_PromptInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_new_project_update_frame_rate_prompt(inputs)
	if (locale === "de") return de_new_project_update_frame_rate_prompt(inputs)
	if (locale === "it") return it_new_project_update_frame_rate_prompt(inputs)
	if (locale === "ru") return ru_new_project_update_frame_rate_prompt(inputs)
	if (locale === "es") return es_new_project_update_frame_rate_prompt(inputs)
	if (locale === "zh-CN") return zh_cn2_new_project_update_frame_rate_prompt(inputs)
	if (locale === "ja") return ja_new_project_update_frame_rate_prompt(inputs)
	if (locale === "hi") return hi_new_project_update_frame_rate_prompt(inputs)
	if (locale === "pt-PT") return pt_pt2_new_project_update_frame_rate_prompt(inputs)
	return en_new_project_update_frame_rate_prompt(inputs)
});